import React, { useContext, useEffect, useState, } from "react";
import { FormContext } from "./FormContext";
import "./FormErrors.scss";
export const FormErrors = ({ title, lysaFormRef, }) => {
    var _a;
    const [inputs, setInputs] = useState();
    const formContext = useContext(FormContext);
    useEffect(() => {
        var _a;
        return (_a = lysaFormRef.current) === null || _a === void 0 ? void 0 : _a.addOnInputUpdate(setInputs);
    }, [lysaFormRef, (_a = lysaFormRef.current) === null || _a === void 0 ? void 0 : _a.addOnInputUpdate]);
    const inputsWithError = inputs === null || inputs === void 0 ? void 0 : inputs.filter(({ isInvalid, errorMessages }) => ((formContext === null || formContext === void 0 ? void 0 : formContext.forceErrors) || isInvalid) && errorMessages.length);
    if (!inputsWithError || !inputsWithError.length) {
        return null;
    }
    return (React.createElement("div", { className: "lysa-form-errors", role: "alert" },
        title && React.createElement("h4", null, title),
        React.createElement("ul", null, inputsWithError.map(({ scrollToRef, label, errorMessages, id }) => {
            return (React.createElement("li", { key: id },
                React.createElement("a", { href: `#${id}`, onClick: (event) => {
                        event.preventDefault();
                        scrollToError(id, scrollToRef);
                    } },
                    React.createElement("span", null,
                        label && (React.createElement(React.Fragment, null,
                            label,
                            " - ")), errorMessages === null || errorMessages === void 0 ? void 0 :
                        errorMessages.join(", ")))));
        }))));
};
export function scrollToError(inputId, scrollToRef) {
    if (!document) {
        return;
    }
    const inputElement = document.getElementById(inputId);
    const scrollToElement = (scrollToRef === null || scrollToRef === void 0 ? void 0 : scrollToRef.current) || inputElement;
    if (!document || !scrollToElement) {
        return;
    }
    scrollToElement.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth",
    });
    if (inputElement) {
        (function checkIfInView() {
            if (scrollToElement.offsetTop >= window.pageYOffset &&
                scrollToElement.offsetTop <= window.pageYOffset + window.innerHeight) {
                inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus({ preventScroll: false });
            }
            else {
                setTimeout(checkIfInView, 50);
            }
        })();
    }
}
